export default __webpack_public_path__ + "static/B0152-235eaafb7e14ba0ac26e3e589a7a52a9.png";